<template>
  <div id="app">

    <!-- navBar (fixed; keeps visible while scrolling) -->
    <navbar></navbar>

    <main class="app-main-shell">
      <router-view />
    </main>
    
    <!-- footer -->
    <footer-div></footer-div>

  </div>
</template>

<script>
import store from "./store/index.js"
import { applyDocumentLang } from './utils/documentLang.js'
import navbar from './components/topNavBar/TopNavBar.vue'
import footerDiv from './components/footer/Footer.vue'

export default {
  data() {
    return {
      form: "",
      accountType: null,
      isLoginPage: true
    };
  },
  components: {
    navbar,
    footerDiv
  },
  watch: {
    '$route' () {
      this.isLoginPage = true;
      if (this.$route.name === 'login') {
        this.isLoginPage = false;
      } else {
        this.isLoginPage = true;
      }
    },
    '$store.state.theme'(t) {
      this.applyDocumentTheme(t)
    },
    '$store.state.lang'(lang) {
      applyDocumentLang(lang)
    },
  },
  created() {
    this.isLoginPage = true;
    if (this.$route.name === 'login' || this.$route.name === 'landingPage') {
      this.isLoginPage = false;
    } else {
      this.isLoginPage = true;
    }

    this.lang = store.getters.getlang
    this.langIsEng = this.lang === 'en'
    store.commit("SET_INTERNATIONALIZATION", this.lang)
    applyDocumentLang(this.lang)
    this.applyDocumentTheme(this.$store.state.theme)
  },
  mounted() {
    this.applyDocumentTheme(this.$store.state.theme)
  },
  methods: {
    applyDocumentTheme(t) {
      const dark = t === 'dark'
      document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
      document.documentElement.style.colorScheme = dark ? 'dark' : 'light'
    }
  }
};
</script>
<style scoped lang="scss">

  @font-face {
    font-family: "cairo-bold";
    src: url("../src/assets/fonts/Cairo-Bold.ttf");
  }
  @font-face {
    font-family: "cairo-regular";
    src: url("../src/assets/fonts/Cairo-Regular.ttf");
  }
  /* Matches fixed navbar height; يُورَّث لـ sticky تحت الشريط */
  #app {
    --app-navbar-offset: 5.35rem;
    /* مسافة أوضح تحت الشريط — عناصر position:sticky تُثبَّت من أعلى الـ viewport */
    --app-sticky-top: calc(var(--app-navbar-offset) + 1rem);
  }

  @media (max-width: 1199.98px) {
    #app {
      --app-navbar-offset: 5.1rem;
      --app-sticky-top: calc(var(--app-navbar-offset) + 1rem);
    }
  }

  @media (max-width: 575.98px) {
    #app {
      --app-navbar-offset: 4.85rem;
      --app-sticky-top: calc(var(--app-navbar-offset) + 0.85rem);
    }
  }

  .app-main-shell {
    padding-top: var(--app-navbar-offset);
  }

  body {
    margin: 0;
    padding: 0;
    font-family: "cairo-regular" !important;
    -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  }
  .pageContent{
    width: 100%;
    float: left;
    padding: 30px;
    padding-left: 0px;
    padding-right: 0px;
  }
  button .btn-primary{
    color: #fff;
    background-color: #006633 !important;
    border-color: #006633 !important;
  }
  @media (max-width: 1100px) {
    .pageContent{
      width: 93%;
      float: left;
      padding: 30px;
    }
  }
  @media (max-width: 800px) {
    .pageContent{
      width: 91%;
      float: left;
      padding: 30px;
    }
  }
  @media (max-width: 600px) {
    .pageContent{
      width: 100%;
      float: left;
      padding: 10px;
    }
  }
</style>